import React, { useEffect, useState } from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceArea,
  Text,
} from "recharts";
import { Row, Col, Form, Select, DatePicker } from "antd";
import styled from "styled-components";
import { StyledTable } from "atoms/Table";
import dayjs from "dayjs";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import { uniqBy } from "lodash";

const { RangePicker } = DatePicker;

const Customstyle = styled.div`
  .title {
    color: #636980;
  }
  .rows {
    display: flex;
    justify-content: space-between;
  }
  .col-label {
    color: #636980;
  }
  .col-value {
    margin-left: 40px;
    width: 98px;
    height: 18px;
    gap: 0px;
    opacity: 0px;
  }
  .text {
    font-size: 16px;
    font-weight: 400;
  }
  .footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 78%;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 54px;
    background: white;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  }
  .footer-button {
    width: 100px;
    height: 35px;
    font-size: 16px;
    border-radius: 8px;
  }
  .parent-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .averagescore {
    width: 200px;
    height: 35px;
    border-radius: 8px;
    padding-right: 10px;
    padding-top: 5px;
    color: #636980;
    background-color: #f4f4f4;
    display: flex;
    justify-content: flex-end;
  }
  .score {
    font-weight: 500;
  }
  .matrix {
    height: 100%;
  }
  .matrixright {
    margin-top: 5px;
    font-size: 14px;
    font-weight: 400px;
    color: #636980;
    line-height: 10.26px;
    padding-top: 20px;
  }
  .recommendtext {
    color: #636980;
  }
  .count {
    color: black;
  }
  .appraiser {
    display: flex;
    gap: 300px;
  }
  .final {
    margin-top: -5px;
  }
`;

const Styleddiv = styled.div`
.consolidated{
  display:flex;
  justify-content:center;
  align-items:center
}
  .search-type-date {
    display: flex;
    gap: 24px;
  }
  .searchbar {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .type-dropdown {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .date-picker {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .ant-picker-input {
    display: flex;
    align-items: center;
  }

  .ant-picker-suffix {
    order: -1; /* This moves the icon to the front */
    margin-right: 8px; /* Optional: adjust the space between the icon and the placeholder */
  }
  .ant-table-thead > tr > th {
    font-weight: 500;
    font-size: 16px;
  }
  .ant-table-tbody > tr > td {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }

  .normal-column {
    min-width: 300px;
    white-space: normal;
  }

  .action-icons {
    display: none;
    position: absolute;
  }

  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 12px;
    cursor: pointer;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #52c41a !important; /* Green */
    border-color: #52c41a !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #52c41a !important;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-inner {
    width: 16px;
    height: 16px;
  }
  .hovered-row {
    width: 100px;
    display: flex;
    gap: 1rem;
    opacity: 1;
  }
  .row-table {
    width: 100px;
    opacity: 0;
  }

  .table_action_icon {
    background-color: #c2fae5;
    color: black;
    cursor: pointer;
  }
  .custom-row {
    height: 50px; /* Adjust row height */
  }

  .custom-row td {
    padding: 10px; /* Adjust cell padding */
  }
  .custom-select .ant-select-selection-placeholder {
    color: black !important;
  }

  .custom-select .ant-select-selector {
    border-radius: 24px !important;
    color: black !important;
    width: 250px !important; /* Optional, if you want a fixed width */
  }
`;

const StyledRangePicker = styled(RangePicker)`
  width: 240px !important;
  border-radius: 24px !important;
  margin-left: 10px;
`;

const borderedAreas = [
  { x1: 0, x2: 2, y1: 4, y2: 6, fill: "#FFC000", label: "6" },
  { x1: 2, x2: 4, y1: 4, y2: 6, fill: "#00B050", label: "3" },
  { x1: 4, x2: 6, y1: 4, y2: 6, fill: "#7030A0", label: "1" },
  { x1: 0, x2: 2, y1: 2, y2: 4, fill: "#FF0000", label: "8" },
  { x1: 2, x2: 4, y1: 2, y2: 4, fill: "#FFC000", label: "5" },
  { x1: 4, x2: 6, y1: 2, y2: 4, fill: "#00B050", label: "2" },
  { x1: 0, x2: 2, y1: 0, y2: 2, fill: "#FF0000", label: "9" },
  { x1: 2, x2: 4, y1: 0, y2: 2, fill: "#FF0000", label: "7" },
  { x1: 4, x2: 6, y1: 0, y2: 2, fill: "#FFC000", label: "4" },
];

const Consolidated = ({ contractData }) => {
  const [form] = Form.useForm();

  const [showDateRange, setShowDateRange] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const { Option } = Select;

  const handleFilter = (data) => {
    const type = data?.type || [];
    const performanceContractName = data?.name || [];
    const selectedDate = data?.date;


    const today = dayjs().endOf("day");
    let start = null;
    let end = null;

    // Handle date range logic
    if (selectedDate === "All") {
      setShowDateRange(false);
    } else if (selectedDate === "Last week") {
      start = dayjs().subtract(7, "days").startOf("day");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "Last month") {
      start = dayjs().subtract(1, "months").startOf("month");
      end = dayjs().subtract(1, "months").endOf("month");
      setShowDateRange(false);
    } else if (selectedDate === "Last 6 months") {
      start = dayjs().subtract(6, "months").startOf("month");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "custom") {
      setShowDateRange(true);
      if (fromDate && toDate) {
        start = fromDate;
        end = toDate;
      } else {
        start = null;
        end = null;
      }
    } else if (selectedDate) {
      // If manually selected specific date
      const parsed = dayjs(selectedDate, "DD-MM-YYYY");
      start = parsed.startOf("day");
      end = parsed.endOf("day");
    }

    const sourceData = contractData;

    return contractData?.filter((item) => {
      const typeMatch = type.length > 0 ? type.includes(item?.period) : true;

      const nameMatch =
        performanceContractName.length > 0
          ? performanceContractName.includes(item?.userid)
          : true;

      const dateMatch =
        start && end
          ? dayjs(item?.attendedon)?.isSameOrBefore(end, "day") &&
            dayjs(item?.attendedon)?.isSameOrAfter(start, "day")
          : true;
      return typeMatch && nameMatch && dateMatch;
    });
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };

  useEffect(() => {
    handleFormChange();
  }, [contractData, fromDate, toDate]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "25%",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      width: "25%",
      render: (text, record) => {
        return text?.map((item) => item)?.join(", ");
      },
    },
    {
      title: "Attended on",
      dataIndex: "attendedon",
      key: "attendedon",
      width: "25%",
      render: (text, record) => {
        return dayjs(text).isValid() ? dayjs(text).format("DD-MM-YYYY") : "-";
      },
    },
    {
      title: "Soft skill",
      dataIndex: "x",
      key: "x",
      width: "25%",
      render: (text) => {
        return text?.toFixed(2);
      },
    },
    {
      title: "Technical skill",
      dataIndex: "y",
      key: "y",
      width: "25%",
      render: (text) => {
        return text?.toFixed(2);
      },
    },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = [payload[0].payload];
      return (
        <StyledTable
          columns={columns}
          dataSource={data}
          style={{ width: 700 }}
          rowClassName={() => "custom-row"}
          pagination={false}
          footer={() =>
            data?.[0]?.contractstatus === "draft" ? (
              <div style={{ textAlign: "right", fontWeight: 500 }}>Draft</div>
            ) : null
          }
        />
      );
    }

    return null;
  };

  const datas = filteredData?.map((item) => {
    return {
      x: Number(item?.averagesoftscore) || 0,
      y: Number(item?.averagetechnicalscore) || 0,
      fullname: item?.fullname,
      attendedon: item?.attendedon,
      department: item?.leveldepartmentname,
      contractstatus: item?.contractstatus,
    };
  });

  //   const datas = [
  //     { x: 0, y: 0 },
  //     { x: 0, y: 2 },
  //   ];
  return (
    <Styleddiv>
      <Customstyle>
        {/* <h6>Performance Matrix</h6> */}
        <Form
          form={form}
          layout="vertical"
          className="mt-2"
          onValuesChange={handleFormChange}
        >
          <Row gutter={12} className="g-3 mb-2">
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <DropdownCheckBox
                name="name"
                label="Search"
                options={uniqBy(
                  contractData?.map((val) => ({
                    label: val.fullname,
                    value: val.userid,
                  })),
                  "value"
                )}
                form={form}
                handleFormChange={handleFormChange}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <DropdownCheckBox
                name="type"
                label="Period"
                options={[
                  {
                    value: "Half Yearly Appraisal",
                    label: "Half Yearly",
                  },
                  { value: "Quarterly Appraisal", label: "Quarterly" },
                  { value: "Yearly Appraisal", label: "Yearly" },
                ]}
                form={form}
                handleFormChange={handleFormChange}
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Form.Item name="date" label="" className="search-type-date">
                <Select
                  placeholder="Date"
                  value={selectedDateRange}
                  onChange={handleSelectChange}
                  className="custom-select"
                >
                  <Option value="All">All</Option>
                  <Option value="Last week">Last Week</Option>
                  <Option value="Last month">Last Month</Option>
                  <Option value="Last 6 months">Last 6 Months</Option>
                  <Option value="custom">Custom</Option>
                </Select>
              </Form.Item>
            </Col>
            {showDateRange && (
              <Form.Item>
                <StyledRangePicker
                  format="DD-MM-YYYY"
                  onChange={(dates) => {
                    setFromDate(dates ? dates[0] : null);
                    setToDate(dates ? dates[1] : null);
                  }}
                />
              </Form.Item>
            )}
          </Row>
        </Form>

         {datas.length > 0 ? (
          <>
        
          <div className="matrix">
          <ScatterChart
            width={900}
            height={400}
            margin={{ top: 0, right: 20, bottom: 40, left: 40 }}
          >
            <CartesianGrid stroke="#ccc" />
            <XAxis
              type="number"
              dataKey="x"
              name="Soft Skills"
              domain={[0, 6]}
              tickCount={4}
              label={{
                value: "<------Soft Skills------>",
                position: "bottom",
                dy: -20,
              }}
              tick={false}
              axisLine={{ stroke: "#ddd" }}
            />
            <YAxis
              type="number"
              dataKey="y"
              name="Technical Skills"
              domain={[0, 6]}
              tickCount={4}
              label={{
                value: "<------Technical Skills------>",
                angle: -90,
                position: "insideLeft",
                dx: 30, // Moves label slightly left for better alignment
                dy: 0, // Centers the label vertically
                style: { textAnchor: "middle" }, // Ensures text is centered
              }}
              tick={false}
              axisLine={{ stroke: "#ddd" }}
            />

            {/* <Tooltip cursor={{ strokeDasharray: "3 3" }} /> */}
            <Tooltip
              content={<CustomTooltip />}
              cursor={{ strokeDasharray: "3 3" }}
            />

            {/* Render Grid with Labels */}
            {borderedAreas.map((area, index) => (
              <ReferenceArea
                x1={area.x1}
                x2={area.x2}
                y1={area.y1}
                y2={area.y2}
                fill={area.fill}
                stroke="#fff"
                strokeWidth={2}
                label={{
                  position: "insideBottomRight",
                  value: `${area.label}`,
                  fill: "#fff",
                  fontSize: 16,
                }}
              />
            ))}

            {/* Black Dot for a Data Point */}
            <Scatter data={datas} fill="black" shape="circle" />
          </ScatterChart>
        </div>
        
        <div>
          <Row>
            <Col xs={24} md={12}>
              <div className="">
                <p>
                  <span className="count">1</span>&nbsp;&nbsp; Star (High
                  Competence, High Commitment)
                </p>
                <p>
                  <span className="count">2</span>&nbsp;&nbsp; High Potential
                  (Moderate Competence, High Commitment)
                </p>
                <p>
                  <span className="count">3</span>&nbsp;&nbsp; Top Performer
                  (High Competence, Moderate Commitment)
                </p>
                <p>
                  <span className="count">4</span>&nbsp;&nbsp; Dedicated Learner
                  (Low Competence, High Commitment)
                </p>
                <p>
                  <span className="count">5</span>&nbsp;&nbsp; Repable Performer
                  (Moderate Competence, Moderate Commitment)
                </p>
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="">
                <p>
                  <span className="count">6</span>&nbsp;&nbsp; Skilled but
                  Unmotivated (High Competence, Low Commitment)
                </p>
                <p>
                  <span className="count">7</span>&nbsp;&nbsp;&nbsp;
                  Inconsistent Performer (Low Competence, Moderate Commitment)
                </p>
                <p>
                  <span className="count">8</span>&nbsp;&nbsp; Under-performer
                  (Moderate Competence, Low Commitment)
                </p>
                <p>
                  <span className="count">9</span>&nbsp;&nbsp; Disengaged (Low
                  Competence, Low Commitment)
                </p>
              </div>
            </Col>
          </Row>
        </div>
        </>
        ) : (
        <div
                   style={{
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     height: 300,
                   }}
                 >
                   <FolderIcon
                     style={{ width: 200, height: 200, marginBottom: 10 }}
                   />{" "}
                   <p
                     style={{ fontSize: 18, color: "#999", textAlign: "center" }}
                   >
                     {" "}
                     No Data
                   </p>
             </div>
)}
      </Customstyle>
      

    </Styleddiv>
  );
};

export default Consolidated;
